import React, { useEffect, useRef, useState } from 'react';
import { Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8 } from '../Image_exports/HomaPageCarousel.jsx';
import '../../CustomAssets/Css/Components/Carousel.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Carousel({ direction = "ltr" }) {

    const logos = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8];

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,        
    cssEase: "linear",     
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 1,
    speed: 11000,
    rtl: direction === "rtl",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: false,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
        }
      }
    ]
  };
  return (

    <div className="sponsor-slider">
      <div className="container">
        <div className="row">
          <div className="sponsor__company" id="sponsor__company">
              <div className="slider-container">
                <Slider {...settings}>
                  {logos.map((Logo, index) => (
                    <div key={index} className="brand_logo_carousel_imgs">
                      <Logo />
                    </div>
                  ))}
                </Slider>
              </div>
          </div>
        </div>
      </div>
    </div>


  );
}

export default Carousel;
